import DemandContainer from '@components/containers/demand';
import AppLayout from '@layouts/AppLayout';
import { type FC } from 'react';

const DemandPage: FC = () => {
    return (
        <AppLayout>
            <DemandContainer />
        </AppLayout>
    );
};

export default DemandPage;
